import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const Accordion = ({ items, accentColor = '#2D5A3D' }) => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <div className="divide-y" style={{ borderColor: 'rgba(45,90,61,0.15)' }}>
      {items.map((it, idx) => {
        const open = openIdx === idx;
        return (
          <div key={idx} className="py-4" style={{ borderColor: 'rgba(45,90,61,0.15)' }}>
            <button
              onClick={() => setOpenIdx(open ? null : idx)}
              className="flex items-center justify-between w-full text-left gap-4"
            >
              <span className="text-[15px] md:text-[16px]" style={{ color: accentColor }}>
                {it.q || it.title}
              </span>
              <span
                className="shrink-0 w-7 h-7 rounded-full border flex items-center justify-center"
                style={{ borderColor: accentColor, color: accentColor }}
              >
                {open ? <Minus size={14} /> : <Plus size={14} />}
              </span>
            </button>
            <div
              className="grid transition-all duration-300"
              style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
            >
              <div className="overflow-hidden">
                <p className="pt-3 text-[14px] leading-relaxed opacity-90" style={{ color: accentColor }}>
                  {it.a || it.body}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
